import Paper, { PaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

const FlatPaper = styled(Paper)(() => ({ borderRadius: '8px', padding: '24px' }));

const ContentContainer: FC<PaperProps> = props => <FlatPaper elevation={0} {...props}></FlatPaper>;

export { ContentContainer };
